const hy = {
  titles: {
    contactUs: 'Կապ մեզ հետ',
    addQuestion: 'Ավելացրեք ձեր հարցը',
  },
};

export default hy;
